import athleteLayout from './../../../layouts/athlete/athlete.vue'
import athleteService from './../../../services/athlete'
import hofService from './../../../services/hof'
import store from './../../../store'
import {filter, includes, map} from 'lodash'

export default {
  components: {
    VLayout: athleteLayout,
  },

  created () {
    hofService.find()
    athleteService.find(this.$route.params.athleteId, this.$route.params.hof)
  },

  destroyed () {
    store.dispatch('getTeams', {})
    store.dispatch('setAthletes', {})
  },

  computed: {
    teamList () {
      let teamList = {}
      const hofTeams = filter(store.state.teams.teams, (team) => {
        return includes(store.state.hof.all.teams, team.teamName)
      })
      if (hofTeams.length > 0) {
        teamList['hof'] = map(hofTeams, (team) => {return store.getters.getHofTeam(team.teamName)})
      }
      const regularTeams = store.state.teams.teams
      if (regularTeams.length > 0) {
        teamList['regular'] = regularTeams
      }
      return teamList
    },
    isAthleteInHallOfFame () {
      return includes(store.state.hof.all.athletes, store.state.athletes.all.id)
    },
    athlete () {
      return store.state.athletes.all
    },
    hofRecord () {
      return store.getters.getHofAthlete(this.athlete.id) || {}
    },
  },

  methods: {
    isTeamInHallOfFame (team) {
      return !team.hallOfFame && includes(store.state.hof.all.teams, team.teamName)
    },
  },
}
